import { AlignmentOptions, WidthOptions } from '@/types';
import { Tabs as TabsComponent } from '@/ui';
import clsx from 'clsx';

import { FlexibleData } from '@/lib/server';

import { PageRender } from '../util/page-render';
import { BlockBase, Margin, childClassNames, columnsClassName, getMarginClassNames } from './utils';

export interface TabsProps extends BlockBase {
  orientation?: 'horizontal' | 'vertical';
  margin: Margin;
  blockWidth: WidthOptions;
  contentAlignment: AlignmentOptions;
  tabs: {
    title: string;
    content: FlexibleData;
  }[];
}

export function Tabs({
  orientation = 'horizontal',
  tabs,
  params,
  id,
  margin,
  blockWidth,
  contentAlignment,
}: TabsProps) {
  return (
    <TabsComponent
      id={id}
      orientation={orientation}
      classNames={{
        content: clsx(columnsClassName, childClassNames, 'py-2 pt-8 lg:pt-16', {
          'justify-start text-start':
            contentAlignment?.alignment?.horizontalAlignment === 'left' ||
            !contentAlignment?.alignment?.horizontalAlignment,
          'justify-center text-center': contentAlignment?.alignment?.horizontalAlignment === 'center',
          'justify-end text-end': contentAlignment?.alignment?.horizontalAlignment === 'right',
          'items-start':
            contentAlignment?.alignment?.verticalAlignment === 'top' || !contentAlignment?.alignment?.verticalAlignment,
          'items-center': contentAlignment?.alignment?.verticalAlignment === 'middle',
          'items-end': contentAlignment?.alignment?.verticalAlignment === 'bottom',
        }),
        container: clsx(getMarginClassNames(margin), '-translate-y-6 px-4 sm:px-8'),
        root: clsx({
          'max-w-none': blockWidth === 'full',
          'max-w-[theme(screens.3xl)]': blockWidth === 'desktop',
          'max-w-(--breakpoint-2xl)': blockWidth === 'wide',
          'max-w-(--breakpoint-xl)': blockWidth === 'standard' || !blockWidth,
          'max-w-(--breakpoint-lg)': blockWidth === 'narrow',
          'max-w-(--breakpoint-md)': blockWidth === 'prose',
        }),
        listContainer: 'sticky top-20 sm:top-24 pt-4 sm:pt-2 z-30',
        list: 'shadow-lg',
      }}
      items={tabs?.map((item) => ({
        title: item.title,
        content: <PageRender data={item.content} params={params} />,
      }))}
    />
  );
}
